import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function SettleTotal() {

    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
